// extracted by mini-css-extract-plugin
export var button = "header-module--button--590c8";
export var header = "header-module--header--17fe8";
export var icon = "header-module--icon--9fdbc";
export var inner = "header-module--inner--ed169";
export var lines = "header-module--lines--169c5";
export var links = "header-module--links--925ee";
export var logo = "header-module--logo--72edd";
export var logoFull = "header-module--logo-full--d6e44";
export var logoSmall = "header-module--logo-small--d27ff";
export var navlogo = "header-module--navlogo--bd022";
export var toggle = "header-module--toggle--7a33d";